import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { class: "d-flex justify-content-between mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_icon_close = _resolveComponent("icon-close");
    const _component_icon_delete = _resolveComponent("icon-delete");
    const _component_icon_sendmail = _resolveComponent("icon-sendmail");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "taskTitle text-center" }, " Confermi la rimozione? ", -1)),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                class: "btn btn-link text-warning",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.dont && _ctx.dont(...args)))
            }, [
                _createVNode(_component_icon_close),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ms-1" }, " Annulla ", -1))
            ]),
            _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.ok && _ctx.ok(...args)))
            }, [
                _createVNode(_component_icon_delete),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ms-1" }, " Elimina task ", -1))
            ]),
            _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_ctx.okAndMail && _ctx.okAndMail(...args)))
            }, [
                _createVNode(_component_icon_sendmail),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ms-1" }, " Elimina e invia email ", -1))
            ])
        ])
    ]));
}
